module.exports = __webpack_public_path__ + "img/construction.d550a022.png";